import wixData from 'wix-data';
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
import { getCategoryByPostId, getCategoryByCategoryId } from 'backend/dataModule'
import moment from 'moment'

export function renderRepeaterData(repeaterId, options = {}) {
    const isMobile = wixWindow.formFactor === "Mobile";

    $w(`#${repeaterId}`).onItemReady(($item, itemData, index) => {

        $item(`#${repeaterId}Button`).target = "_self";
		$item(`#${repeaterId}Button`).label = "";
        $item(`#${repeaterId}Button`).link = itemData.postPageUrl;
        $item(`#${repeaterId}Title`).text = itemData.title
        $item(`#${repeaterId}TitleHover`).text = itemData.title
        $item(`#${repeaterId}Image`).src = itemData.coverImage

        const itemIsBlogPost = !itemData.isLoadingPlaceholder

        if (itemIsBlogPost) {

            if (options.renderExcerpt) {
                $item(`#${repeaterId}Excerpt`).text = itemData.excerpt
            }

            if (itemData.omitDate) {
                $item(`#${repeaterId}Date`).text = ''
            } else {
                const publishedDate = moment(itemData.publishedDate).format('DD, MMM YY')
                $item(`#${repeaterId}Date`).text = publishedDate
            }

            if (!options.omitCategory) {
                if (itemData.categories) {
                    const categoryId = itemData.categories[0]._id

                    getCategoryByCategoryId(categoryId).then(category => {
                        $item(`#${repeaterId}Category`).text = category.label
                    })
                } else {
                    getCategoryByPostId(itemData._id).then(category => {
                        $item(`#${repeaterId}Category`).text = category.label
                    })
                }
            }

        }

        const fadeOptions = { "duration": 200 }

        if (!isMobile) {
            $item(`#${repeaterId}Button`).onMouseIn(() => {
                clearHoverEffects(repeaterId);
                $item(`#${repeaterId}TitleHover`).show();
                $item(`#${repeaterId}Title`).hide();
            })
            $item(`#${repeaterId}Button`).onMouseOut(() => {
                $item(`#${repeaterId}Title`).show();
                $item(`#${repeaterId}TitleHover`).hide();
                clearHoverEffects(repeaterId);
            })
        }
        if ($w(`#${repeaterId}`).hidden) {
            $w(`#${repeaterId}`).show("fade", fadeOptions)
        }
    })

    // setRepeaterAsLoading(repeaterId)
}

// export function setRepeaterAsLoading(repeaterId) {
// 	const repeaterLoadingData = [{
// 		_id: 'loadingPlaceholder',
// 		title: 'loading...',
// 		isLoadingPlaceholder: true,
// 		coverImage: 'https://static.wixstatic.com/media/623f25_fbe97dc8656e4499a45c287496e4bda3~mv2.png/v1/fill/w_1000,h_1000/Blank.png',
// 		publishedDate: ''

// 	}]
// 	$w(`#${repeaterId}`).data = repeaterLoadingData
// }

export function convertToURL(string) {
    return string.toLowerCase().replace(/ /g, '-')
}

function clearHoverEffects(repeaderId) {
    $w(`#${repeaderId}`).forEachItem(($item, itemData, index) => {
        $item(`#${repeaderId}TitleHover`).hide();
    })
}